import Managers from './Managers';
import WashTraxClient from './washtraxClient';

export default {
  ...Managers,
  ...WashTraxClient,
};